const HCPGrammarParserVisitor = require("./HCPGrammarParserVisitor")
  .HCPGrammarParserVisitor;
class VisitorParser extends HCPGrammarParserVisitor {
  constructor() {
    super();
    this.DatatypeWithVariable = [];
    this.CurrentDatatype = "";
    this.IsArrayVariable = false;
    this.FirstTimeFlag = true;
  }

  visitChildren(ctx) {
    if (ctx.children != null) return this.visit(ctx.children);
    else return null;
  }

  visitProgram(ctx) {
    return this.visitChildren(ctx);
  }
  // Visit a parse tree produced by HCPGrammarParser#sourceElement.
  visitSourceElement(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#statement.
  visitStatement(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#statementList.
  visitStatementList(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#variableStatement.
  visitVariableStatement(ctx) {
    var result = this.visitChildren(ctx);
    //clear the data type variable
    this.CurrentDatatype = "";
    return result;
  }

  // Visit a parse tree produced by HCPGrammarParser#ctypeStatement.
  visitCtypeStatement(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#variableDeclarationList.
  visitVariableDeclarationList(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#ScalarVariableDeclaration.
  visitScalarVariableDeclaration(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#ArrayVariableDeclaration.
  visitArrayVariableDeclaration(ctx) {
    this.IsArrayVariable = true;
    var result = this.visitChildren(ctx);
    this.IsArrayVariable = false;

    return result;
  }

  // Visit a parse tree produced by HCPGrammarParser#emptyStatement.
  visitEmptyStatement(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#expressionStatement.
  visitExpressionStatement(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#ifStatement.
  visitIfStatement(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#vartype.
  visitVartype(ctx) {
    this.CurrentDatatype = ctx.getText();
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#sourceElements.
  visitSourceElements(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#expressionSequence.
  visitExpressionSequence(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#ParenthesizedExpression.
  visitParenthesizedExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#AdditiveExpression.
  visitAdditiveExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#RelationalExpression.
  visitRelationalExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#ArrowPropExpression.
  visitArrowPropExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#LogicalAndExpression.
  visitLogicalAndExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#LiteralExpression.
  visitLiteralExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#LogicalOrExpression.
  visitLogicalOrExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#customFnExpression.
  visitCustomFnExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#NotExpression.
  visitNotExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#MemberIndexExpression.
  visitMemberIndexExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#builtInTimeExpression.
  visitBuiltInTimeExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#AssetConnectionExpression.
  visitAssetConnectionExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#UnaryMinusExpression.
  visitUnaryMinusExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#AssignmentExpression.
  visitAssignmentExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#BitAndExpression.
  visitBitAndExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#IdentifierRightExpression.
  visitIdentifierRightExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#BitOrExpression.
  visitBitOrExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#UnaryPlusExpression.
  visitUnaryPlusExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#builtInFnExpression.
  visitBuiltInFnExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#EqualityExpression.
  visitEqualityExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#BitXOrExpression.
  visitBitXOrExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#MultiplicativeExpression.
  visitMultiplicativeExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#BitShiftExpression.
  visitBitShiftExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#IdentifierNameIndexedArray.
  visitIdentifierNameIndexedArray(ctx) {
    this.IsArrayVariable = true;
    var result = this.visitChildren(ctx);
    this.IsArrayVariable = false;

    return result;
  }

  // Visit a parse tree produced by HCPGrammarParser#IdentifierNameEmptyArray.
  visitIdentifierNameEmptyArray(ctx) {
    this.IsArrayVariable = true;
    var result = this.visitChildren(ctx);
    this.IsArrayVariable = false;

    return result;
  }

  // Visit a parse tree produced by HCPGrammarParser#IdentifierNameOnly.
  visitIdentifierNameOnly(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#identifierSetProps.
  visitIdentifierSetProps(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#identifierGetProps.
  visitIdentifierGetProps(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#builtInfunction.
  visitBuiltInfunction(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#CustomFunctionArgumentsExpression.
  visitCustomFunctionArgumentsExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#CustomFunctionNamedArgumentExpression.
  visitCustomFunctionNamedArgumentExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#timeExpression.
  visitTimeExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#timeExpressionOperator.
  visitTimeExpressionOperator(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#arrowExpression.
  visitArrowExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#StringLiteralExpression.
  visitStringLiteralExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#NumericLiteralExpression.
  visitNumericLiteralExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#timePeriod.
  visitTimePeriod(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#timeConstantColonExpression.
  visitTimeConstantColonExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#timeConstantColonExpression2.
  visitTimeConstantColonExpression2(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#timeConstantLiteral.
  visitTimeConstantLiteral(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#numericLiteral.
  visitNumericLiteral(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#identifierName.
  visitIdentifierName(ctx) {
    var VariableName = ctx.getText();
    var varType = this.CurrentDatatype;
    if (varType == "") {
      varType = "double";
    }
    if (this.FirstTimeFlag) {
      this.FirstTimeFlag = false;
      this.DatatypeWithVariable.push({
        variableName: VariableName,
        variableDataType: varType,
        IsArray: this.IsArrayVariable
      });
    } else {
      var isDuplicate = false;
      for (var i = 0; i < this.DatatypeWithVariable.length; i++) {
        if (this.DatatypeWithVariable[i].variableName == VariableName) {
          isDuplicate = true;
        }
      }
      if (!isDuplicate) {
        this.DatatypeWithVariable.push({
          variableName: VariableName,
          variableDataType: varType,
          IsArray: this.IsArrayVariable
        });
      }
    }

    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#reservedWord.
  visitReservedWord(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#keyword.
  visitKeyword(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#eos.
  visitEos(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by HCPGrammarParser#eos2.
  visitEos2(ctx) {
    return this.visitChildren(ctx);
  }
}
exports.VisitorParser = VisitorParser;
